module.exports = __webpack_public_path__ + "img/cover-inner.0237abf3.png";